import React, { useEffect, useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
// import { combineReducers } from 'redux-immutable';
// import { OneFetchyeProvider, OneCache } from 'fetchye-one-app';
import oneAppModuleWrapper from '@americanexpress/one-app-module-wrapper';
import { useFetchye } from 'fetchye';
import { IntlProvider } from 'react-intl';
import DataManager from '@americanexpress/data-manager';
import { AmexDDLRegister, getAmexDataManagerConfig } from '@americanexpress/data-manager-utils';
import { browserHistory } from '@americanexpress/one-app-router';
import SharedScript, { Ensighten, Qualtrics } from '@americanexpress/shared-scripts';
import { loadLanguagePack, updateLocale } from '@americanexpress/one-app-ducks';
import PropTypes from 'prop-types';
import uuid from 'react-uuid';
import { ProgressCircle } from '@americanexpress/dls-react';
import { Helmet } from 'react-helmet';
import childRoutes from '../childRoutes';
import { getRedirectionUrl } from '../utils/redirection';
// import { getCookie } from '../utils/util';
/* eslint-disable react-hooks/rules-of-hooks -- need */

const {
  ddlProviderProps,
  reactlyticsProps,
} = getAmexDataManagerConfig({
  initialDDL: {
    historyLimit: 20,
    ddl: {
      version: '2.0.7',
      identifier: 'axp-iform-root',
      timestamp: new Date().toISOString(),
      user: { authenticated: true },
    },
  },
});

let mktlocale;

const AXPIformRoot = ({
  children, languageData, locale,
}) => {
  // const [isLoadingChild, setIsLoadingChild] = useState(true);
  // read url and split out locale
  const path = window.location.pathname;

  // check if the url needs to be redirected
  if (path.includes('iforms.do')) {
    const redirectionUrl = getRedirectionUrl(path);
    window.location.href = redirectionUrl;
    return (
      <div className="row">
        <section id="spinner">
          <div className="pad flex flex-justify-center flex-align-items-center">
            <ProgressCircle size="lg" />
          </div>
        </section>
      </div>
    );
  }
  const formLocale = path.split('/')[3].split('?')[0];
  const pageType = path.split('/')[2];
  const [, mktString] = formLocale.split(/_(.*)/s);
  mktlocale = mktString.replace(/_/g, '-');
  const faasApiUrl = useSelector((state) => state.getIn(['config', 'faasApiUrl']));
  const internetIdentityBaseUrls = useSelector((state) => state.getIn(['config', 'internetIdentityBaseUrls']));
  const submitApiUrls = useSelector((state) => state.getIn(['config', 'submitApiUrls']));
  // const appBaseUrls = useSelector((state) => state.getIn(['config', 'appBaseUrls']));
  const [isSessionValid, setIsSessionValid] = useState(false);
  const jId = useMemo(
    () => {
      const id = uuid();
      window.sessionStorage.setItem('jId', id);
      return id;
    }, []);

  const { run } = useFetchye(`${faasApiUrl}/ReadUserSession.v1`, { method: 'GET', credentials: 'include' });
  const [isUrlValid, setIsUrlValid] = useState(true);
  /**
   * splunk logging
   */
  const loggerApiCall = async (log, logType) => {
    const loggerPayload = {
      journeyId: jId,
      cuid: formLocale,
      message: `oneformsUI ${log}`,
      type: logType,
      // additionalAttribute: null,
    };

    const loggerRequestOption = {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(loggerPayload),
    };
    // console.log(loggerPayload.message);
    const response = await fetch(`${submitApiUrls}/iForms/logger?cuid=${formLocale}`, loggerRequestOption);
    const result = await response.json();
    return result;
  };

  /**
   * Append journey ID to the URL
   */
  const appendJourneyId = () => {
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set('journeyId', jId);
    return currentUrl.href;
  };

  useEffect(() => {
    // Append Journey Id to current url
    const locationHref = appendJourneyId();

    const validateSession = async (loginUrl) => {
      const log = 'status=readUserSessionApiCalled';
      loggerApiCall(log, 'info');
      const { data: response } = await run();
      if (response.status !== 200) {
        // This call checks if AAT/JWT is present or not
        // Call fails if the session is invalid
        // i.e. session is invalid and need to create a new one
        // Appending journey ID to the current url
        const destinationUrl = encodeURIComponent(`${locationHref}`);
        const target = `${loginUrl}?DestPage=${destinationUrl}`;
        const logString = `status=readUserSessionApiCallFailed with status=${response.status} and user is redirected to login page with redirectionUrl=${target}`;
        loggerApiCall(logString, 'info');
        window.location.replace(target);
      } else {
        const logString = `status=readUserSessionApiCallSuccess userUrl=${locationHref} state=loadingSecureForm`;
        loggerApiCall(logString, 'info');
        setIsSessionValid(true);
        browserHistory.push(locationHref);
      }
    };
    if (process.env.NODE_ENV !== 'development' && (pageType === 'secure' || pageType === 'at-secure')) {
      let loginUrl;
      switch (pageType) {
        case 'secure':
          loginUrl = `${internetIdentityBaseUrls}/${mktlocale}/account/login`;
          break;
        case 'at-secure':
          loginUrl = `${internetIdentityBaseUrls}/${mktlocale}/account/at-work/login`;
          break;
        default:
          loginUrl = null;
      }
      validateSession(loginUrl);
    } else if (pageType === 'unsecure' || pageType === 'open' || process.env.NODE_ENV === 'development') {
      const logString = `userUrl=${locationHref} state=loadingUnsecureForm`;
      loggerApiCall(logString, 'info');
      setIsSessionValid(true);
      browserHistory.push(locationHref);
    } else {
      setIsUrlValid(false);
    }
  }, []);

  return (
    !isSessionValid ? (
      <div className="row">
        {
          isUrlValid
            ? (
              <section id="spinner">
                <div className="pad flex flex-justify-center flex-align-items-center">
                  <ProgressCircle size="lg" />
                </div>
              </section>
            ) : (
              <div>
                Not Found
              </div>
            )
        }
      </div>
    ) : (
      <IntlProvider locale={locale} messages={languageData}>
        <SharedScript
          name="one-identity-session"
          version="^1.0.0"
          windowCheck="AmexSession"
        />
        <Helmet
          htmlAttributes={{ lang: mktlocale }}
          meta={[
            { 'http-equiv': 'X-UA-Compatible', content: 'IE=edge' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' },
          ]}
          link={[
            {
              rel: 'stylesheet', // TODO: we should generate the below line to use the same version of dls as was installed
              href: 'https://www.aexp-static.com/cdaas/one/statics/@americanexpress/dls/6.25.0/package/dist/6.25.0/styles/dls.min.css',
            },
            {
              rel: 'icon', // TODO: we should generate the below line to use the same version of dls as was installed
              href: 'https://www.aexp-static.com/cdaas/one/statics/@americanexpress/static-assets/2.28.0/package/dist/img/logos/favicon.ico',
              type: 'image/x-icon',
            },
          ]}
        />
        <DataManager
          ddlProviderProps={ddlProviderProps}
          reactlyticsProps={reactlyticsProps}
        >
          <AmexDDLRegister disableRegisterList={{ charset: true, device: true, visitorId: true }} />
          <Ensighten async={true} version="^1.0.0" />
          <Qualtrics async={true} version="^1.0.0" />
          {
            isSessionValid && children
          }
        </DataManager>
      </IntlProvider>
    )
  );
};

export const TestableAXPIformRoot = AXPIformRoot;

AXPIformRoot.propTypes = {
  languageData: PropTypes.shape({}).isRequired, // no need to restate all the keys in the lang pack
  locale: PropTypes.string.isRequired,
  children: PropTypes.element,
};

// Read about childRoutes:
// https://github.com/americanexpress/one-app/blob/main/docs/api/modules/Routing.md#childroutes
AXPIformRoot.childRoutes = childRoutes;

// Read about appConfig:
// https://github.com/americanexpress/one-app/blob/main/docs/api/modules/App-Configuration.md
/* istanbul ignore next */
if (!global.BROWSER) {
  // eslint-disable-next-line global-require -- require needs to be inside browser check
  AXPIformRoot.appConfig = require('../appConfig').default;
}
/* eslint-enable react-hooks/rules-of-hooks -- need */
export const loadModuleData = async ({ store: { dispatch } }) => {
  await dispatch(updateLocale(mktlocale));
  dispatch(loadLanguagePack('axp-iform-root', { fallbackLocale: 'en-US' }));
};

AXPIformRoot.holocron = {
  name: 'axp-iform-root',
  loadModuleData,
  // reducer: combineReducers({
  //   fetchye: OneCache().reducer,
  // }),
};

export default oneAppModuleWrapper('axp-iform-root')(AXPIformRoot);
